import { WEEKDAY_LIST } from "../../../../app/lib/common/helper.lib";

export class DailyRebootInfo {
    static WEEKDAY_SPLIT_CHAR: string = ',';

    private _enabled: boolean = false;
    get enabled(): boolean { return this._enabled; }
    time: string;

    staggerRebootWithinMinutes: number;
    private _daysMap: { [wid: string]: { checked: boolean, day: string, abbr: string } } = {};

    constructor(raw?: { time?: string, days?: string[], staggerRebootWithinMinutes?: number }) {
        this._enabled = raw?.days?.length > 0 ? true : false;
        this.time = raw?.time || '05:00';
        this.staggerRebootWithinMinutes = raw?.staggerRebootWithinMinutes ?? 60;

        this._daysMap = WEEKDAY_LIST.reduce((prev, curr) => {
            const wid: string = curr.substring(0, 3);
            prev[wid] = { day: curr, checked: false, abbr: wid };

            return prev;
        }, {});

        raw?.days?.forEach(wid => {
            if (this._daysMap[wid]) {
                this._daysMap[wid].checked = true;
            }
        });
    }

    enable(enabled: boolean): void {
        if (!this.enabled && Object.values(this._daysMap).filter(wd => wd.checked).length === 0) {
            Object.values(this._daysMap).forEach(wd => wd.checked = true);
            this._enabled = enabled;
        }
        this._enabled = enabled;
    }

    isWeekdayChecked(weekdayId: string): boolean {
        return this._daysMap[weekdayId]?.checked;
    }

    checkWeekday(weekdayId: string, checked: boolean): void {
        this._daysMap[weekdayId].checked = checked;
        if (Object.values(this._daysMap).filter(wd => wd.checked).length === 0) {
            this._enabled = false;
        }
    }

    transformWeekDays(): string[] {
        return this.enabled ? Object.values(this._daysMap).filter(wd => wd.checked).map(wd => wd.abbr) : [];
    }

    export(option?: { supportStagger: boolean }): any {
        return option?.supportStagger ? {
            value: { days: this.transformWeekDays(), time: this.time },
            policyData: { staggerRebootWithinMinutes: this.staggerRebootWithinMinutes }
        } : { days: this.transformWeekDays(), time: this.time };
    }

    static equal(a: DailyRebootInfo, b: DailyRebootInfo): boolean {
        return a.enabled === b.enabled
            && a.time === b.time
            && a.staggerRebootWithinMinutes === b.staggerRebootWithinMinutes
            && a.transformWeekDays().sort().toString() === b.transformWeekDays().sort().toString();
    }
}